import Head from "next/head";
import Footer from "pages/components/Footer";
import StartHumming from "pages/components/StartHumming";
import Topbar from "pages/components/Topbar";
import React from "react";
import { ExtendedNextPage } from "types/pages";

import Content from "components/Content";
import Label from "components/Label";
import styles from "./styles.module.scss";
import { terms } from "./constants";

const Terms: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Terms page</title>
        <meta name="about" content="Humming home's terms page" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Content contentClassName={styles.terms}>
        <Label className={styles.title} variant="h2-centered" color="primary">
          Terms of use
        </Label>
        <Label color="primary" useMarkdown>
          {terms}
        </Label>
      </Content>
      <StartHumming fillColor="primary" />
    </div>
  );
};

Terms.getLayout = (page) => {
  return (
    <div>
      <Topbar withHeader />
      {page}
      <Footer />
    </div>
  );
};

export default Terms;
